<template>
  <v-toolbar flat color="white" class="elevation-1">
    <v-toolbar-title>Instituciones Bancarias</v-toolbar-title>
    <v-divider class="mx-4" inset vertical></v-divider>
    <div class="flex-grow-1"></div>
    <v-dialog
      v-model="entrysDialog"
      max-width="500px"
      v-if="role === this.$store.state.TypeRole.ADMINISTRADOR"
    >
      <template v-slot:activator="{ on }">
        <v-btn color="info" dark class="mb-2" v-on="on">
          <v-icon small>mdi-plus</v-icon>
          <v-divider class="mx-4" inset vertical></v-divider>Agregar
        </v-btn>
      </template>
      <v-form v-model="valid" ref="form" @keyup.native.enter.prevent="valid && add(entry)">
        <v-card>
          <v-card-title>
            <span class="headline">{{ entrysDialogEditMode ? "Editar" : "Crear" }} Banco</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="entry.codigo"
                    :label="capitalize($t('common.code'))"
                    :rules="[rules.required, rules.counterCod]"
                    :maxlength="configRules.maxlength.code"
                    counter
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="entry.nombre"
                    :label="capitalize($t('common.name'))"
                    :rules="[rules.required, rules.counterName]"
                    :maxlength="configRules.maxlength.name"
                    counter
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="error" dark @click="close">
              <v-icon small>mdi-cancel</v-icon>
              <v-divider class="mx-4" inset vertical></v-divider>
              {{ $t("common.close") }}
            </v-btn>
            <v-btn
              v-if="entrysDialogEditMode"
              type="submit"
              form="entryNombreBanco"
              :disabled="!valid || loading"
              color="blue darken-1  white--text"
              @click="update(entry)"
            >
              <v-icon small>mdi-refresh</v-icon>
              <v-divider class="mx-4" inset vertical></v-divider>
              {{ $t("common.update") }}
            </v-btn>
            <v-btn
              v-else
              type="submit"
              form="entryNombreBanco"
              color="blue darken-1  white--text"
              :disabled="!valid || loading || !entry.nombre"
              @click="add(entry)"
            >
              <v-icon small>mdi-content-save</v-icon>
              <v-divider class="mx-4" inset vertical></v-divider>
              {{ $t("common.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex"
import messageMixin from "@/mixins/common"

const configRules = {
  maxlength: {
    code: 4,
    name: 50,
  }
}

export default {
  name: "banco-entry-dialog",
  mixins: [messageMixin],
  data() {
    return {
      valid: false,
      loading: false,
      configRules,
      rules: {
        required: value => !!value || "Requerido.",
        counterCod: value => value.length <= configRules.maxlength.code || `Máximo ${configRules.maxlength.code} carácteres`,
        counterName: value => value.length <= configRules.maxlength.name || `Máximo ${configRules.maxlength.code} carácteres`,
      },
    }
  },
  methods: {
    ...mapMutations("Bancos", ["toggleEntrysDialog"]),
    ...mapActions("Bancos", ["createEntry", "updateEntry"]),
    close() {
      this.toggleEntrysDialog({
        editMode: false,
        entry: {
          codigo: "",
          nombre: "",
        },
      })
    },
    add(entryData) {
      this.loading = true
      this.createEntry(entryData)
        .then(response => {
          this.loading = false

          if (response) {
            this.saveMessage("Banco")
            this.close()
            return
          }

          this.errorMessage(this.messageError)
        })
    },
    update(item) {
      this.loading = true
      this.updateEntry(item)
        .then(response => {
          this.loading = false

          if (response) {
            this.updateMessage("Banco")
            this.close()
            return
          }

          this.errorMessage(this.messageError)
        })
    },
  },
  computed: {
    ...mapGetters("Auth", ["role"]),
    ...mapState("Bancos", ["entry", "messageError"]),
    ...mapGetters("Bancos", ["entrysDialogEditMode", "entryDialog"]),
    entrysDialog: {
      get() {
        return this.entryDialog
      },
      set() {
        this.close()
      },
    },
  },
}
</script>
